import { getOrFetchKnowledgeBaseDomain } from 'core_main/api/knowledge_bases';
import { getStore } from 'core_main/store';
import { PublicCallback } from 'globals/types';

export const getKnowledgeBaseConfig = (cb?: PublicCallback) => {
  return getOrFetchKnowledgeBaseDomain()
    .then(() => {
      const { knowledgeBaseDomain, knowledgeBaseId } = getStore();
      const callbackResponse = {
        knowledgeBaseDomain,
        knowledgeBaseId,
      };
      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
      return callbackResponse;
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to get knowledge base information', error);
    });
};
